import React from "react";
import styled from "styled-components";
import { FormControlLabel, Radio } from "@mui/material";
import { colors, fonts } from "../../components/common/mixins";
import { RadioButton } from "../../components/icons";
import { BREAKPOINT_RESERVATION_PAGE } from "../../pageComponents/reservationPage/constants/breakpoints";

interface DsRadioButtonProps {
  label: React.ReactNode;
  value: string;
  disabled?: boolean;
}

const StyledFormControlLabel = styled(FormControlLabel)`
  width: fit-content;
  & .MuiFormControlLabel-label {
    ${fonts.normalText()};
    color: ${colors.darkBlue};
  }
  && {
    gap: 8px;
  }
`;

export function DsRadioButton({ label, value, disabled }: DsRadioButtonProps) {
  return (
    <StyledFormControlLabel
      value={value}
      label={label}
      disabled={disabled}
      control={
        <Radio
          disableRipple
          icon={<RadioButton color="#D8DBE0" showDot={false} />}
          checkedIcon={<RadioButton />}
          sx={{ padding: "4px", "&:hover": { backgroundColor: "transparent" } }}
        />
      }
    />
  );
}
